<template>
	<div class="min-h-screen flex flex-col bg-white">
		<slot />
		<footer class="mt-auto border-t border-gray-200 px-4 py-6 text-sm text-gray-600 md:px-6 md:text-base">
			<div class="mx-auto max-w-7xl">
				<div class="mt-4">Der EnergieKompass ist ein Service des Landes Salzburg.</div>
				<div class="mt-1 flex flex-wrap gap-x-2">
					<span>© Land Salzburg</span>
					|
					<a
						href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
						target="_blank"
						rel="noopener noreferrer"
						class="underline hover:text-[--rot] hover:underline"
					>
						Impressum
					</a>
					|
					<a
						href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
						target="_blank"
						rel="noopener noreferrer"
						class="underline hover:text-[--rot] hover:underline"
					>
						Rechtliche Hinweise
					</a>
					|
					<a
						href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
						target="_blank"
						rel="noopener noreferrer"
						class="underline hover:text-[--rot] hover:underline"
					>
						Datenschutz
					</a>
				</div>
			</div>
		</footer>
	</div>
</template>
